import './ItemCompForTableInMypackages.css'

import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useCreatePkgReq } from '../../../api/package-req/mutations/useCreatePkgReq'
import { useRejectPkgReq } from '../../../api/package-req/mutations/useRejectPkgReq'
import CustomModalPReq from '../../../Components/CustomModal'
import { PackageRequestButtons } from '../../../Components/PackageRequestButtons/PackageRequestButtons'
import SnackbarModal from '../../../Components/SnackbarModal'
import Tooltip from '../../../Components/Tooltip'
import { getBrandLogo } from '../../../helpers/getBrandLogo'
import { getPrice } from '../../../helpers/getPrice'
import arrowDownIcon from '../../../imgs/arrow-down-svg.svg'
import greeceFlagCircle from '../../../imgs/flags/greece-circle.png'
import ukFlagCircle from '../../../imgs/flags/uk-circle.png'
import usaFlagCircle from '../../../imgs/flags/usa-circle.png'
import flammableImg from '../../../imgs/flammable.png'
//Icons
import infoIcon from '../../../imgs/info.png'
import photoIcon from '../../../imgs/pc-actions/photo-package-icon.svg'
import returnPackageIcon from '../../../imgs/pc-actions/return-package-icon.svg'
import shrinkIcon from '../../../imgs/pc-actions/shrink-package-icon.svg'
//Actions Icons
import uniteIcon from '../../../imgs/pc-actions/unite-package-icon.svg'
import {
  setPackageForPackageDetails,
  setPackageForReceiptUpload,
  setPackageForReturn,
  setPackageForReturnLabelUpload,
} from '../../../store/packageSlice'
//Modals
import { ContentCheckModal, ErrorModal, InfoModal } from './ModalsForItem'

export default function ItemCompForTableInMypackages(props) {
  const { item, onChangeCheckBox, setCountry, setUniteMode, submitCancelUniteHandler, setUniteId } = props
  const { isUniteMode, EURToUSD, GBPToUSD } = useSelector(state => state.packages)
  const dispatch = useDispatch()
  const history = useHistory()
  const [isMobile, setisMobile] = useState(false)
  const [isShowTools, setIsShowTools] = useState(false)
  const { mutateAsync: rejectPackageReqMutation } = useRejectPkgReq()
  const { mutateAsync: createPackageReqMutation } = useCreatePkgReq()
  //fix receipt:
  // const [showFixReceiptModal, setShowFixReceiptModal] = useState(false)
  // const [isFixingReceipt, setIsFixingReceipt] = useState(false)
  // const [errorMsg, seterrorMsg] = useState('')
  // const [errorModalShow, seterrorModalShow] = useState(false)

  //modals
  const [showInfoModal, setshowInfoModal] = useState(false)
  const [showErrorModal, setshowErrorModal] = useState(false)
  const [showContentCheckModal, setsshowContentCheckModal] = useState(false)
  const [showPhotoRequest, setShowPhotoRequest] = useState(false)
  const [showReturnRequest, setShowReturnRequest] = useState(false)
  const [showShrinkRequest, setShowShrinkRequest] = useState(false)
  const [showUniteRequest, setshowUniteRequest] = useState(false)

  const [showCancelPhotoRequest, setShowCancelPhotoRequest] = useState(false)
  const [showCancelShrinkRequest, setShowCancelShrinkRequest] = useState(false)
  const [showCancelUniteRequest, setShowCancelUniteRequest] = useState(false)
  // const [showCancelReturnRequest, setshowCancelReturnRequest] = useState(false)

  const [showPhotoReqSuccessSnackBar, setShowPhotoReqSuccessSnackBar] = useState(false)
  const [showShrinkReqSuccessSnackBar, setShowShrinkReqSuccessSnackBar] = useState(false)
  const [showReturnReqSuccessSnackBar, setShowReturnReqSuccessSnackBar] = useState(false)
  const processBtnRef = useRef(null)

  //tooltip state
  const [visibleTooltip, setVisibleTooltip] = useState(null)

  useEffect(() => {
    setisMobile(window.matchMedia('only screen and (max-width: 768px)').matches)
  }, [])

  const createTooltipCloser = tooltipId => isOpen => {
    if (!isOpen) {
      setVisibleTooltip(currentlyVisible => (currentlyVisible === tooltipId ? null : currentlyVisible))
    }
  }

  const onChangeCheckBoxHandler = e => {
    if (e.target.checked) document.getElementById(`${item.id}c`).classList.add('pc-checked')
    else document.getElementById(`${item.id}c`).classList.remove('pc-checked')
    onChangeCheckBox(e)
  }

  // const fixReceipt = async () => {
  //   setIsFixingReceipt(true)

  //   const params = {
  //     packageId: item.id,
  //     updateParam: {
  //       buyingReciptKey: null,
  //       reqType: 'fixReceipt',
  //     },
  //   }

  //   try {
  //     await dispatch(updatePackageAction(params))
  //   } catch (error) {
  //     seterrorMsg('תקלה בשרת! אנא נסה שנית או פנה לשירות הלקוחות')
  //     seterrorModalShow(true)
  //   } finally {
  //     setShowFixReceiptModal(false)
  //     setIsFixingReceipt(false)
  //   }
  // }

  // const toggleTrackNum = () => {
  //   setIsShowTrackNum(!isShowTrackNum)

  //   if (trackNumRef.current) {
  //     trackNumRef.current.classList.toggle('pc-tracknum-active')
  //   }
  // }

  // const toggleWeight = () => {
  //   setIsShowWeight(!isShowWeight)

  //   if (weightRef.current) {
  //     weightRef.current.classList.toggle('pc-weight-active')
  //   }
  // }

  // const toggleContent = () => {
  //   setIsShowContent(!isShowContent)

  //   if (contentRef.current) {
  //     contentRef.current.classList.toggle('pc-content-active')
  //   }
  // }

  const toggleTools = () => {
    // if (item.isForUnite) {
    //   return
    // }

    setIsShowTools(!isShowTools)
  }

  const getCanUnite = () => {
    if (
      !item.isForUnite &&
      isUniteMode &&
      !item.isPaid &&
      !item.isShipped &&
      !item.isdraft &&
      !item.isReturnRequestActive &&
      !item.isShrinkRequestActive &&
      !item.isPhotoRequestActive
    ) {
      return true
    } else return false
  }

  const handleGoToUploadPage = () => {
    dispatch(setPackageForReceiptUpload(item))
    history.push(`/receipt-upload`)
  }

  const getValue = () => {
    if (item.valueInUSD) return `${item.valueInUSD}$`
    else if (item.price > 0) return `${getPrice(item, EURToUSD, GBPToUSD)}$`
    return '-'
  }

  const getContentCount = () => {
    const totalCount = item?.contents?.reduce((acc, c) => acc + +c.quantity, 0)
    return totalCount
  }

  const getCountryFlag = country => {
    switch (country) {
      case 'GR':
        return greeceFlagCircle
      case 'USA':
        return usaFlagCircle
      case 'UK':
        return ukFlagCircle
    }
  }

  const handleReq = async (reqType, args) => {
    if (reqType === 'returnRequest') {
      dispatch(setPackageForReturn(item))
      history.push('/return-package')
      return
    }
    const data = {
      packageId: item.id,
      reqType,
    }
    if (reqType === 'shrinkRequest') {
      data.shrinkNotes = args
    }

    try {
      await createPackageReqMutation(data)
      //show snackbar
      switch (reqType) {
        case 'photoRequest':
          setShowPhotoReqSuccessSnackBar(true)
          break
        case 'shrinkRequest':
          setShowShrinkReqSuccessSnackBar(true)
          break
        case 'returnRequest':
          setShowReturnReqSuccessSnackBar(true)
          break
      }
    } catch (error) {
      setshowErrorModal(true)
      console.log(error)
    }
  }

  const handleCancelReq = async reqType => {
    const data = {
      reqType,
      packageId: item.id,
      rejectReason: 'userCanceled',
    }

    switch (reqType) {
      case 'photoRequest':
        data.packageReqId = item.photoRequestId
        break
      case 'shrinkRequest':
        data.packageReqId = item.shrinkRequestId
        break
      case 'returnRequest':
        data.packageReqId = item.returnRequestId
        break
    }
    // console.log('handleCancelReq - data:', data)

    try {
      await rejectPackageReqMutation(data)
    } catch (error) {
      setshowErrorModal(true)
      console.log(error)
    }
  }

  const navigateToPackageDetails = item => {
    dispatch(setPackageForPackageDetails(item))
    history.push('/package-details')
  }

  const navigateToReturnLableUploadPage = item => {
    dispatch(setPackageForReturnLabelUpload(item))
    history.push('/package-return-label')
  }

  const handleUniteReq = () => {
    setCountry(item.warehouse)
    setUniteMode(true)
    window.scrollTo(0, 0)
  }

  // Package Request Handlers
  const handleShrinkReq = () => setShowShrinkRequest(true)
  const handlePhotoReq = () => setShowPhotoRequest(true)
  const handleReturnReq = () => setShowReturnRequest(true)
  const handleCancelUniteReq = () => {
    setUniteId(item.uniteID)
    setShowCancelUniteRequest(true)
  }
  const handleCancelShrinkReq = () => setShowCancelShrinkRequest(true)
  const handleCancelPhotoReq = () => setShowCancelPhotoRequest(true)

  const getBadge = () => {
    if (item.isPhotoRequestActive || item.isShrinkRequestActive || item.isReturnRequestActive || item.isForUnite)
      return 'בקשה ממתינה לביצוע'
    return 'מוכן למשלוח'
  }

  const getMainBtn = () => {
    // console.log('item', item)
    if (item.isPhotoRequestActive || item.isShrinkRequestActive || item.isForUnite)
      return (
        <>
          <div className='package-card-btn pcb-disabled' ref={processBtnRef} onClick={() => setVisibleTooltip('processingTip')}>
            בקשה ממתינה לביצוע
          </div>
          <Tooltip
            title='בקשה בטיפול'
            description='לא ניתן לשלח את החבילה כשיש בקשה בטיפול'
            isTooltipOpen={visibleTooltip === 'processingTip'}
            setIsTooltipOpen={createTooltipCloser('processingTip')}
            triggerRef={processBtnRef}
          />
        </>
      )

    if (item.isPaid && !item.isShipped) return <div className='package-card-btn pcb-disabled'>ממתין למשלוח</div>

    if (item.isReturnRequestActive && item.returnLabelFalse)
      return (
        <div className='package-card-btn' onClick={() => navigateToReturnLableUploadPage(item)}>
          העלה תווית החזרה
        </div>
      )

    if (item.isReturnRequestActive && !item.returnLabelFalse) return <div className='package-card-btn pcb-disabled'>ממתין להחזרה</div>

    return (
      <div className='package-card-btn' onClick={() => setsshowContentCheckModal(true)}>
        המשך לשליחה
      </div>
    )
  }

  return (
    <>
      {isMobile ? (
        <div className='package-card' key={item.id} id={`${item.id}c`}>
          {getCanUnite() && (
            <div className='pc-unite'>
              <div
                className={
                  'pc-checkbox-cont' +
                  (item.delayState === 'SUBTRACT' || item.isShrinkRequestActive || item.isReturnRequestActive ? '' : ' glow')
                }
              >
                <input
                  disabled={item.delayState === 'SUBTRACT' || item.isShrinkRequestActive || item.isReturnRequestActive}
                  type='checkbox'
                  value={item.id}
                  onChange={e => onChangeCheckBoxHandler(e)}
                />
              </div>
            </div>
          )}
          <img src={getCountryFlag(item.warehouse)} alt={item.warehouse} className='pc-flag' />

          <div className='package-card-top'>
            <div className='pc-brand-cont'>
              <img src={getBrandLogo(item.brand)} alt={item.brand} className='pc-brand-img' />
              <div className='pc-brand-title'>{item.brand.toUpperCase()}</div>
            </div>

            <div className='pc-top-left'>
              <div className='pc-top-left-badge'>{getBadge()}</div>
            </div>
          </div>

          <div className='package-card-content'>
            <div className='package-card-content-cube'>
              <span style={{ color: '#666666' }}> תאריך הגעה</span>{' '}
              <span style={{ fontSize: '14px' }}>{item.dateArrived.split('-').reverse().join('.')}</span>{' '}
            </div>
            <div className='package-card-content-cube'>
              <span style={{ color: '#666666' }}> משקל</span> <span style={{ fontSize: '14px' }}> {item.weight}KG</span>
            </div>
            <div className='package-card-content-cube'>
              <span style={{ color: '#666666' }}> כמות</span> <span style={{ fontSize: '14px' }}>{getContentCount()} פריטים</span>
            </div>
          </div>

          <div className='package-card-bot'>{!isUniteMode && getMainBtn()}</div>

          {!isUniteMode && (
            <>
              <div className='package-card-extra'>
                <div style={{ color: ' #00AEFF' }} onClick={() => navigateToPackageDetails(item)}>
                  לפרטים נוספים
                </div>

                <div className='package-card-extra-actions'>
                  {!item.isPaid && (
                    <div onClick={toggleTools} style={{ display: 'flex', alignItems: 'center' }}>
                      <span> פעולות נוספות </span>
                      <img src={arrowDownIcon} alt='arrow' />
                    </div>
                  )}
                </div>
              </div>

              <div className={`pc-tools-cont ${isShowTools ? 'pc-tools-active' : ''}`}>
                <PackageRequestButtons
                  item={item}
                  onUniteRequest={handleUniteReq}
                  onReturnRequest={handleReturnReq}
                  onShrinkRequest={handleShrinkReq}
                  onPhotoRequest={handlePhotoReq}
                  onCancelUniteRequest={handleCancelUniteReq}
                  onCancelShrinkRequest={handleCancelShrinkReq}
                  onCancelPhotoRequest={handleCancelPhotoReq}
                />
              </div>
            </>
          )}
        </div>
      ) : (
        <tr key={item.id} style={{ height: '95px' }}>
          <td>
            {getCanUnite() && (
              <div>
                {/* <Form.Check
                      value={item.id}
                      onChange={onChangeCheckBox}
                      aria-label="option 1"
                    /> */}
                <div className='pc-checkbox-cont'>
                  <input type='checkbox' value={item.id} onChange={e => onChangeCheckBox(e)} />
                </div>
              </div>
            )}
          </td>

          <td onClick={() => navigateToPackageDetails(item)}>
            <img src={getCountryFlag(item.warehouse)} alt={item.warehouse} width='40px' />
          </td>
          <td onClick={() => navigateToPackageDetails(item)}>
            <img src={getBrandLogo(item.brand)} alt={item.brand} className='pc-brand-img' />
            <br />
            {item.brand}
          </td>
          <td onClick={() => navigateToPackageDetails(item)}>{item.dateArrived.split('-').reverse().join('.')}</td>
          <td style={{ textAlign: 'center' }} onClick={() => navigateToPackageDetails(item)}>
            {getValue()}
          </td>

          <td style={{ direction: 'ltr' }}>
            <span
              className='package-card-bot-i'
              onClick={() => setshowInfoModal(true)}
              style={{ fontWeight: 'normal', marginRight: '2px' }}
            >
              {item.isFlammable && <img src={flammableImg} alt='flammable' />}
              <img src={infoIcon} alt='info' />
            </span>
            {item?.contents?.map((c, i) => {
              return (
                <span key={i}>
                  {i > 0 && ', '}
                  {c.quantity} {c.productCategory}
                </span>
              )
            })}
          </td>

          <td onClick={() => navigateToPackageDetails(item)}>
            {item.length}x{item.height}x{item.width}
            <br />
            {item.weight}KG
          </td>

          <td onClick={() => navigateToPackageDetails(item)}>{item.trackingNumberInTurkey}</td>
          <td>
            <PackageRequestButtons
              item={item}
              onUniteRequest={handleUniteReq}
              onReturnRequest={handleReturnReq}
              onShrinkRequest={handleShrinkReq}
              onPhotoRequest={handlePhotoReq}
              onCancelUniteRequest={handleCancelUniteReq}
              onCancelShrinkRequest={handleCancelShrinkReq}
              onCancelPhotoRequest={handleCancelPhotoReq}
            />
          </td>
          <td>{!isUniteMode && getMainBtn()}</td>
        </tr>
      )}

      <InfoModal showInfoModal={showInfoModal} setshowInfoModal={setshowInfoModal} />
      <ErrorModal showErrorModal={showErrorModal} setshowErrorModal={setshowErrorModal} />
      <ContentCheckModal
        showContentCheckModal={showContentCheckModal}
        setsshowContentCheckModal={setsshowContentCheckModal}
        handleGoToUploadPage={handleGoToUploadPage}
      />

      {/* Unite Request Modal */}
      <CustomModalPReq
        showModal={showUniteRequest}
        setShowModal={setshowUniteRequest}
        confirmFunction={handleUniteReq}
        title='רוצה לאחד חבילות?'
        body={
          <p>
            אנחנו נאחד עבורך חבילות וכך ייחסכו דמי המשלוח!
            <br />
            רק שימו לב שגובה המיסוי משתנה בהתאם לסך כל המוצרים בחבילה המאוחדת.
            <br />
            ההזמנות שלך מפוצלות? מגיע לך איחוד חינם!
            <br />
            בלחיצה על כפתור האישור-תועבר לבחירה של החבילות לאיחוד
          </p>
        }
        confirmBtnText='כן, אחדו לי חבילות'
        modalLogo={uniteIcon}
        badgeText='השירות כרוך בתשלום של $1.5 שיופיע בחשבון לאחר הביצוע'
      />

      {/* Shrink Request Modal */}
      <CustomModalPReq
        showModal={showShrinkRequest}
        setShowModal={setShowShrinkRequest}
        confirmFunction={() => handleReq('shrinkRequest')}
        title='רוצה לצמצם את נפח האריזה שלך?'
        body={
          <p>
            אנחנו דואגים לחבילה שלך!
            <br />
            ברוב המקרים אנחנו מסירים אריזות אוטומטית,
            <br />
            כאן השארנו אותן כי המוצר אינו טקסטיל וייתכן שהוא רגיש.
            <br />
            נוכל לצמצם בכל זאת – אך שים/י לב:
            <br />
            אין אחריות על נזק למוצרים לאחר הסרת אריזות,
            <br />
            במיוחד אם הם שבירים
          </p>
        }
        confirmBtnText='בואו נצמצם'
        modalLogo={shrinkIcon}
        badgeText='השירות כרוך בתשלום של $5 שיופיע בחשבון לאחר הביצוע'
        textArea={true}
      />

      {/* Photo Request Modal */}
      <CustomModalPReq
        showModal={showPhotoRequest}
        setShowModal={setShowPhotoRequest}
        confirmFunction={() => handleReq('photoRequest')}
        title='רוצה לראות מה יש בחבילה שלך?'
        body={
          <p>
            אנחנו נצלם עבורך את החבילה
            <br />
            ונעלה את התמונה לחשבון שלך.
            <br />
            היא תופיע ממש כאן ותהיה זמינה להורדה
          </p>
        }
        confirmBtnText='כן, צלמו לי את החבילה'
        modalLogo={photoIcon}
        badgeText='השירות כרוך בתשלום של $5 שיופיע בחשבון לאחר הביצוע'
      />

      {/* Return Request Modal */}
      <CustomModalPReq
        showModal={showReturnRequest}
        setShowModal={setShowReturnRequest}
        confirmFunction={() => handleReq('returnRequest')}
        title='רוצה להחזיר את החבילה שלך?'
        body={
          <p>
            אנחנו נחזיר עבורך את החבילה לספק.
            <br />
            בלחיצה על כפתור האישור-תועבר לעמוד החזרת חבילה
          </p>
        }
        confirmBtnText='כן, אני רוצה להחזיר את החבילה שלי'
        modalLogo={returnPackageIcon}
        badgeText='השירות כרוך בתשלום של $10'
      />

      {/* Unite Request success Modal - in TableForMyPackagesPage cmp*/}
      {/* Shrink Request success Modal */}
      <SnackbarModal
        showModal={showShrinkReqSuccessSnackBar}
        setShowModal={setShowShrinkReqSuccessSnackBar}
        iconType='approve'
        title='הבקשה לצמצום התקבלה!'
        description='נטפל בזה תוך 2 ימי עסקים ונעדכן אותך כשהתהליך יושלם'
      />

      {/* Photo Request success Modal */}
      <SnackbarModal
        showModal={showPhotoReqSuccessSnackBar}
        setShowModal={setShowPhotoReqSuccessSnackBar}
        iconType='approve'
        title='בקשת הצילום התקבלה!'
        description='נעדכן אותך כשהתמונה תהיה מוכנה להורדה'
      />

      {/* Return Request success Modal */}
      <SnackbarModal
        showModal={showReturnReqSuccessSnackBar}
        setShowModal={setShowReturnReqSuccessSnackBar}
        iconType='approve'
        title='החבילה בדרך חזרה!'
        description='נעדכן אותך ברגע שהבקשה תטופלוהחבילה תוחזר לחנות'
      />

      {/* Cancel Unite Modal */}
      <SnackbarModal
        showModal={showCancelUniteRequest}
        setShowModal={setShowCancelUniteRequest}
        iconType='cancel'
        title='האם לבטל את הבקשה לאיחוד?'
        description='אם תרצה, תוכל לשלוח בקשה חדשה מאוחר יותר'
        buttons={[
          { label: 'בטל בקשה', onClick: () => submitCancelUniteHandler(), primary: true },
          { label: 'לא עכשיו', onClick: () => setShowCancelUniteRequest(false) },
        ]}
      />

      {/* Cancel Shrink Modal */}
      <SnackbarModal
        showModal={showCancelShrinkRequest}
        setShowModal={setShowCancelShrinkRequest}
        iconType='cancel'
        title='האם לבטל את הבקשה לצמצום?'
        description='אם תרצה, תוכל לשלוח בקשה חדשה מאוחר יותר'
        buttons={[
          { label: 'בטל בקשה', onClick: () => handleCancelReq('shrinkRequest'), primary: true },
          { label: 'לא עכשיו', onClick: () => setShowCancelShrinkRequest(false) },
        ]}
      />

      {/* Cancel Photo Request Modal */}
      <SnackbarModal
        showModal={showCancelPhotoRequest}
        setShowModal={setShowCancelPhotoRequest}
        iconType='cancel'
        title='האם לבטל את הבקשה לצילום?'
        description='אם תרצה, תוכל לשלוח בקשה חדשה מאוחר יותר'
        buttons={[
          { label: 'בטל בקשה', onClick: () => handleCancelReq('photoRequest'), primary: true },
          { label: 'לא עכשיו', onClick: () => setShowCancelPhotoRequest(false) },
        ]}
      />
      {/* Cancel Return Request Modal - Not exist*/}
    </>
  )
}
